import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-039ff109"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "router-vertical-tab__left" }
const _hoisted_2 = { class: "router-vertical-tab__content" }
const _hoisted_3 = { class: "router-vertical-tab__sign" }

import { computed, PropType, inject } from 'vue';
import { RouteLocationRaw, RouterLink, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'router-vertical-tab',
  props: {
  route: {
    type: Object as PropType<RouteLocationRaw>,
    required: true,
  },
  label: {
    type: String as PropType<string | null>,
  },
  paragraph: {
    type: String as PropType<string | null>,
  },
  currentTab: {
    type: String,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();



const routeFullPath = computed(() => router.resolve(props.route).fullPath);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterLink), {
    class: _normalizeClass(["router-vertical-tab", { 'router-vertical-tab--active': __props.currentTab.includes(routeFullPath.value) }]),
    to: routeFullPath.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "left")
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
        _renderSlot(_ctx.$slots, "paragraph")
      ])
    ]),
    _: 3
  }, 8, ["class", "to"]))
}
}

})